import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import {
  AssetType,
  AssetTypeDataIn,
  Client,
} from '../../../../../api/api-reference';

@Component({
  selector: 'app-asset-type-setup',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule, FormsModule],
  templateUrl: './asset-type-setup.component.html',
  styleUrl: './asset-type-setup.component.scss',
})
export class AssetTypeSetupComponent implements OnInit {
  @Input() selectedAssetType: string | null = null;
  @Output() close = new EventEmitter<boolean>();
  data: AssetTypeDataIn = new AssetTypeDataIn();
  isUsedInLimiter: boolean = false;

  assetTypes = Object.values(AssetType);

  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getAssetType();
  }

  getAssetType() {
    if (this.selectedAssetType) {
      this.client.getAssetType(this.selectedAssetType).subscribe({
        next: (response) => {
          this.data.id = response.id;
          this.data.name = response.name ?? '';
          this.data.code = response.code ?? '';
          this.data.assetType = response.assetType;
          this.data.applyLimiterConfiguration = response.applyLimiterConfiguration;
          this.isUsedInLimiter = response.isUsedInLimiter;
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    }
  }

  toggleModal(reaload?: boolean) {
    this.close.emit(reaload);
  }

  onSubmit() {
    this.client.saveAssetType(this.data).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.toggleModal(true);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
